import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { REWARD_APP_PREVIEW_EXPIRY_DISPLAY_FORMAT } from './reward-app-preview.constants';

/**
 * Presentational Chick-fil-A App reward preview (phone chrome + screen).
 * Used by Spotlight template-preview and CFA One Giveaway flows.
 */
@Component({
  selector: 'shared-reward-app-preview',
  templateUrl: './reward-app-preview.component.html',
  styleUrls: ['./reward-app-preview.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SharedRewardAppPreviewComponent {
  /** Primary title line (e.g. Spotlight: "To you, from {location}"; Giveaway: reward headline). */
  @Input() public primaryHeading = '';
  @Input() public rewardProductName = '';
  @Input() public rewardGiftMessage = '';
  @Input() public rewardProductImageUrl = '';
  @Input() public rewardExpiryDate = REWARD_APP_PREVIEW_EXPIRY_DISPLAY_FORMAT;
  @Input() public rewardOperatorImageUrl = '';
  @Input() public includeOperatorPhoto = true;
  @Input() public rewardOperatorName = '';
  /** When true, omits the operator / gifter row (Giveaway). Spotlight leaves false for unchanged layout. */
  @Input() public hideGiftedSection = false;
}
